module.exports = __webpack_public_path__ + "9a25c41f35742226ab41a96aa36b060b.m4a";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/sounds/notification.m4a
// module id = 150
// module chunks = 0